import React from 'react';
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import AuthMenu from 'game/app/components/layout/auth-menu';
import {Link, Route, Switch, withRouter} from "react-router-dom";
import NavbarRound1 from './menu/round-1';
import NavbarRound2 from './menu/round-2';
import NavbarRound3 from './menu/round-3';
import {NavbarToggler} from "reactstrap";
import NavbarGameDefault from './menu/game-default';
import assets from 'game/app/assets';
import GameComponent from "game/app/components/game/game-component";

class Navbar extends GameComponent {

    constructor(params) {
        super(params);
        this.state = { toggle: false }
    }

    toggleMobile = (e) => {
        e.preventDefault();
        this.props.sidebarToggleMobile();
    };

    toggleDesktop = (e) => {
        e.preventDefault();
        this.props.sidebarToggle();
    };

    toggle = () => {
        this.setState({...this.state, toggle: !this.state.toggle});
    };

    hide = () => {
        this.setState({...this.state, toggle: false});
    };

    gameInfo() {
        let instance = this.props.gameInstance.instance;

        let money = this.getInstanceProperty('STATS_MONEY');
        let satisfaction = this.getInstanceProperty('STATS_SATISFACTION');
        let chechtaky = this.getInstanceProperty('STATS_CHECHTAKY');

        return (
            <ul className='resources'>
                <li>
                    <img src={assets.profil}/>
                    <strong>{ this.getProfileProperty('category') }</strong><br/>
                    { this.getProfileProperty('name') }
                </li>
                <li>
                    <img src={assets.resources.money_small}/>
                    <div>Peníze</div>
                    <div className='value'><span className={(money < 0 ? 'text-danger' : '')}>{ money.toLocaleString(this.locale) } Kč</span></div>
                </li>
                <li>
                    <img src={assets.resources.satisfaction_small}/>
                    <div>Spokojenost</div>
                    <div className='value'><span className={(satisfaction < 0 ? 'text-danger' : '')}>{ satisfaction } %</span></div>
                </li>
                <li>
                    <img src={assets.resources.chechtaky}/>
                    <div>Chechtáky</div>
                    <div className='value'><span className={(chechtaky < 0 ? 'text-danger' : '')}>{ chechtaky }</span></div>
                </li>
                <li>
                    <img src={assets.state}/>
                    <div>Aktuální kolo</div>
                    { instance.getCurrentNodeTitle() }
                </li>
            </ul>
        );
    }

    shouldDisplayGameInfo() {
        let { pathname } = this.props.location || { pathname: '' };
        return this.props.gameInstance.instance && this.getProfile() && pathname.startsWith('/game/');
    }

    render() {
        let displayGameInfo = this.shouldDisplayGameInfo();

        return (
            <nav className="navbar page-header navbar-light navbar-expand-lg fixed-top bg-white">
                <div className='upper-menu'>
                    <Link to='/' className="navbar-brand"><img src={assets.rozpoctisito} id='logo'/></Link>
                    <NavbarToggler onClick={this.toggle}/>
                    { displayGameInfo && this.gameInfo() }
                    <div className={`collapse navbar-collapse ${this.state.toggle ? 'show' : ''}`}>
                        <AuthMenu hide={this.hide}/>
                    </div>
                </div>
                <Switch>
                    <Route path='/game/:instance_id/round-1' render={() => <NavbarRound1 toggle={this.state.toggle} /> }/>
                    <Route path='/game/:instance_id/round-2' render={() => <NavbarRound2 toggle={this.state.toggle} /> }/>
                    <Route path='/game/:instance_id/round-3' render={() => <NavbarRound3 toggle={this.state.toggle} /> }/>
                    <Route path='/game/:instance_id' render={() => <NavbarGameDefault toggle={this.state.toggle} /> }/>
                    <Route render={() => null}/>
                </Switch>
            </nav>
        )
    }
}


function mapStateToProps(state,ownProps) {
    return {
        gameInstance: state.gameInstance,
        auth: state.auth,
        sidebarToggle: ownProps.sidebarToggle,
        sidebarToggleMobile: ownProps.sidebarToggleMobile
    };
}

function matchDispatchToProps(dispatch){
    return bindActionCreators({
    }, dispatch);
}

export default withRouter(connect(mapStateToProps, matchDispatchToProps)(Navbar));
